{
  "fr": {
    "nav": {
      "raffles": "Tirages au sort",
      "raffle": "Tirage au sort",
      "admin": {
        "raffles": {
          "index": "Tirages au sort",
          "new": "Nouveau tirage au sort",
          "edit": "Modifier le tirage au sort",
          "entries": "Participations au tirage au sort"
        }
      },
      "raffleClaim": "Réclamer le prix",
      "settings": {
        "raffles": "Mes tirages au sort"
      }
    },
    "title": {
      "raffles": "Tirages au sort",
      "raffle": "Tirage au sort",
      "admin": {
        "raffles": {
          "index": "Tirages au sort",
          "new": "Nouveau tirage au sort",
          "edit": "Modifier le tirage au sort",
          "entries": "Participations au tirage au sort"
        }
      },
      "raffleClaim": "Réclamer le prix",
      "settings": {
        "raffles": "Mes tirages au sort"
      }
    },
    "headlines": {
      "admin": {
        "raffles": {
          "index": "Tirages au sort",
          "new": "Nouveau tirage au sort",
          "edit": "Modifier le tirage au sort",
          "entries": "Participations au tirage au sort"
        }
      },
      "settings": {
        "raffles": "Mes tirages au sort"
      }
    },
    "labels": {
      "raffle": {
        "title": "Titre",
        "prize": "Lot",
        "prizeInfo": "Ce que reçoit le gagnant, tel qu'affiché à côté du tirage. Obligatoire pour publier.",
        "description": "Description",
        "descriptionInfo": "Markdown. Écrivez un vaisseau ou un objet sous la forme [*Nom*] pour le lier ; tapez [* pour chercher.",
        "translationInfo": "Facultatif. Un champ laissé vide affiche le texte anglais.",
        "importFolderInfo": "Remplissez toutes les langues et la galerie d'un coup depuis un dossier : un en.md, de.md, … par langue avec le titre et le lot dans un bloc front matter, plus des images. Rien n'est enregistré avant que vous n'enregistriez.",
        "imagesUploading": "Envoi des images : %{count}",
        "code": "Code cadeau",
        "codeInfo": "Le code que reçoit le gagnant. Il est stocké chiffré et n'est plus jamais affiché en entier.",
        "codeSet": "Un code est défini (%{code}). Laissez le champ vide pour le conserver.",
        "codeFrozen": "Le code ne peut plus être modifié après le tirage.",
        "startsAt": "Ouverture le",
        "endsAt": "Clôture le",
        "claimPeriodDays": "Délai de réclamation (jours)",
        "claimPeriodDaysInfo": "Le temps dont dispose un gagnant pour cliquer sur le lien de l'e-mail de réclamation avant que le gain ne passe au suivant dans l'ordre.",
        "published": "Publié",
        "publishedInfo": "Seuls les tirages au sort publiés sont listés et ouverts aux participations. La publication nécessite un code cadeau.",
        "status": "Statut",
        "entriesCount": "Participations",
        "entriesCountValue": "Participations : %{count}",
        "statuses": {
          "draft": "Brouillon",
          "upcoming": "À venir",
          "open": "Ouvert",
          "closed": "Clôturé",
          "drawn": "Tiré",
          "concluded": "Conclu"
        },
        "drawnInfo": "Tiré",
        "drawnBy": "Tiré le %{date} par %{admin}.",
        "currentWinner": "Gagnant actuel : %{username}",
        "claimDeadline": "Date limite de réclamation : %{date}",
        "runDays": "Durée (jours)",
        "runDaysInfo": "Le nombre de jours pendant lesquels le tirage au sort est ouvert aux participations, à compter de son ouverture.",
        "images": "Images",
        "imagesInfo": "La première image sert de couverture sur les cartes et la page d'accueil.",
        "cover": "Couverture",
        "socialPosts": "Publications pour X",
        "claimedInfo": "Réclamé le %{date}. E-mail du code cadeau : %{mail}.",
        "claimPending": "Lien de réclamation envoyé à %{email} (%{mail}). La période de réclamation se termine le %{date}.",
        "overview": {
          "title": "Aperçu",
          "prize": "Lot",
          "code": "Code cadeau",
          "noCode": "Non défini",
          "startsAt": "Ouverture",
          "endsAt": "Clôture",
          "runDays": "Durée",
          "claimPeriodDays": "Délai pour réclamer",
          "days": "%{days} jours",
          "startAnnouncedAt": "Ouverture annoncée",
          "lastDayAnnouncedAt": "Rappel du dernier jour",
          "drawnAt": "Tiré au sort",
          "drawnBy": "%{date} par %{admin}",
          "concludedAt": "Terminé",
          "publicPage": "Ouvrir la page publique",
          "noImages": "Aucune image. Il en faut une pour publier.",
          "previewInfo": "Un lien qui montre ce tirage au sort, même en brouillon, à toute personne qui l'a. Aucun compte requis. Valable 30 jours.",
          "copyPreview": "Copier le lien d'aperçu",
          "openPreview": "Ouvrir l'aperçu"
        }
      },
      "raffleEntry": {
        "username": "Participant",
        "drawPosition": "Position",
        "conditionsAcceptedAt": "Conditions acceptées",
        "state": "État",
        "accountDeleted": "Compte supprimé",
        "states": {
          "claimed": "Réclamé",
          "forfeited": "Perdu",
          "passedOver": "Passé",
          "winner": "Gagnant",
          "waiting": "En attente",
          "notDrawn": "Non éligible"
        },
        "mail": "E-mails",
        "claimMail": "E-mail de réclamation",
        "prizeMail": "E-mail du code",
        "mailStatuses": {
          "sent": "envoyé",
          "delivered": "distribué",
          "bounced": "rejeté"
        },
        "warnings": "Alertes",
        "warningLabels": {
          "sharedIp": "IP partagée",
          "sameInbox": "Même boîte",
          "newAccount": "Nouveau compte",
          "noEmail": "Sans e-mail"
        },
        "warningDetails": {
          "sharedIp": "Même IP de connexion que : %{usernames}. Souvent un foyer ou un réseau mobile.",
          "sameInbox": "Même boîte e-mail que : %{usernames}. Probablement la même personne.",
          "newAccount": "Compte créé moins d'un jour avant la participation.",
          "noEmail": "Aucune adresse e-mail sur le compte. Ignoré lors du tirage."
        }
      },
      "admin": {
        "resourceAccess": {
          "privileges": {
            "raffles": "Tirages au sort"
          }
        }
      },
      "notificationTypes": {
        "raffle_won": "Tirage au sort gagné",
        "raffle_started": "Tirage au sort ouvert",
        "raffle_last_day": "Tirage au sort bientôt clos",
        "raffle_email_missing": "La participation au tirage au sort nécessite une adresse e-mail"
      }
    },
    "placeholders": {
      "raffle": {
        "title": "Gagnez un Polaris",
        "description": "Ce qu'il y a à gagner et comment",
        "code": "XXXX-XXXX-XXXX",
        "claimPeriodDays": "3",
        "runDays": "14",
        "prize": "Pack de jeu Anvil Polaris"
      }
    },
    "messages": {
      "raffle": {
        "created": "Tirage au sort créé.",
        "updated": "Tirage au sort mis à jour.",
        "destroyed": "Tirage au sort supprimé.",
        "createFailed": "Impossible de créer le tirage au sort.",
        "updateFailed": "Impossible de mettre à jour le tirage au sort.",
        "drawn": "Tirage au sort effectué.",
        "drawFailed": "Impossible d'effectuer le tirage au sort.",
        "invalid": "Vérifiez les champs signalés : le tirage au sort a besoin d'un titre, d'une date d'ouverture et d'une durée.",
        "imported": "Dossier importé (langues : %{languages}, images : %{images}). Vérifiez le formulaire et enregistrez.",
        "importSkipped": "Fichiers ignorés : %{files}",
        "importEmpty": "Le dossier ne contient ni fichier de langue ni image.",
        "importUploadFailed": "Ces images n'ont pas pu être envoyées : %{files}"
      },
      "confirm": {
        "raffle": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce tirage au sort ? Cette action est irréversible.",
          "draw": "Effectuer le tirage au sort maintenant ? L'ordre de tous les participants est fixé définitivement et le tirage ne pourra pas être refait."
        }
      }
    },
    "actions": {
      "raffle": {
        "entries": "Participations",
        "draw": "Tirer au sort",
        "importFolder": "Importer un dossier"
      }
    },
    "raffles": {
      "title": "Tirages au sort",
      "lead": "Gagnez des codes cadeaux pour des vaisseaux de Star Citizen. Participez à un tirage au sort ouvert ; à sa clôture, le gagnant est tiré au hasard.",
      "empty": "Il n'y a aucun tirage au sort en ce moment.",
      "status": "Statut",
      "runs": "Période",
      "endsAt": "Clôture le %{date}",
      "entriesCount": "Participants : %{count}",
      "entered": "Vous participez à ce tirage au sort.",
      "statuses": {
        "draft": "Brouillon",
        "upcoming": "À venir",
        "open": "Ouvert",
        "closed": "Clôturé, en attente du tirage",
        "drawn": "Tiré",
        "concluded": "Terminé"
      },
      "entrants": {
        "title": "Participants",
        "empty": "Personne n'a encore participé.",
        "count": "Participants",
        "titleCount": "Participants · %{count}",
        "showAll": "Afficher les %{count}"
      },
      "winner": {
        "title": "Gagnant",
        "pending": "%{username} a gagné et a jusqu'au %{date} pour réclamer le code cadeau.",
        "claimed": "%{username} a gagné et a réclamé le code cadeau.",
        "forfeited": "Non réclamé à temps",
        "claimedPill": "Réclamé",
        "until": "jusqu'au %{date}",
        "drawnOn": "Tiré le %{date} parmi %{count} participants."
      },
      "over": {
        "title": "Ce tirage au sort est terminé",
        "closed": "Les participations sont closes. Le gagnant sera bientôt tiré au sort.",
        "drawn": "Les participations sont closes et le gagnant a été tiré au sort.",
        "concluded": "Le tirage au sort est terminé. Merci à toutes celles et ceux qui ont participé."
      },
      "won": {
        "title": "Vous avez gagné !",
        "checkMail": "Nous vous avons envoyé un e-mail avec un lien pour réclamer votre prix. Cliquez dessus avant le %{date}, sinon le gain passe au suivant dans l'ordre.",
        "claimed": "Prix réclamé",
        "codeSent": "Votre code cadeau est en route vers votre boîte de réception."
      },
      "actions": {
        "enter": "Participer au tirage au sort",
        "withdraw": "Se retirer",
        "signInToEnter": "Connectez-vous pour participer à ce tirage au sort",
        "addEmail": "Ajouter une adresse e-mail"
      },
      "messages": {
        "entered": "Vous participez au tirage au sort. Bonne chance !",
        "withdrawn": "Vous vous êtes retiré du tirage au sort.",
        "confirmWithdraw": "Se retirer de ce tirage au sort ?",
        "forbidden": "Seuls les comptes avec une adresse e-mail confirmée peuvent participer. Confirmez votre adresse e-mail et réessayez.",
        "failed": "Une erreur s'est produite. Veuillez réessayer."
      },
      "conditions": {
        "title": "Conditions de participation",
        "accept": "J'ai lu et j'accepte les conditions de participation.",
        "confirmedAccount": "Seuls les comptes avec une adresse e-mail confirmée peuvent participer, une fois par compte.",
        "noMaintainers": "Les mainteneurs de Fleetyards ne peuvent pas participer.",
        "publicEntrants": "Votre nom d'utilisateur est affiché publiquement sur cette page en tant que participant.",
        "publicWinner": "Si vous gagnez, votre nom d'utilisateur est affiché publiquement en tant que gagnant.",
        "drawOrder": "À la clôture du tirage au sort, tous les participants éligibles sont tirés dans un ordre aléatoire unique. Le premier dans cet ordre gagne.",
        "claimMail": "Le gagnant reçoit un e-mail avec un lien pour réclamer le prix. Le prix n'est jamais affiché sur ce site.",
        "claimDeadline": "Le gagnant dispose de %{days} jours pour cliquer sur ce lien. Sans clic dans les temps, le gain passe au suivant dans l'ordre, qui reçoit son propre e-mail.",
        "prizeMail": "Un clic sur le lien envoie le code cadeau par e-mail à l'adresse du compte gagnant.",
        "deletedAccount": "Les participants dont le compte n'est plus confirmé au moment de leur tour sont passés. Si votre compte est supprimé, votre participation est conservée et un gain est envoyé par e-mail à l'adresse avec laquelle vous avez participé.",
        "noCash": "Le lot est uniquement un code cadeau. Il n'existe aucune contrepartie en espèces et il ne peut pas être échangé.",
        "noLiability": "Fleetyards n'est pas responsable du code cadeau, de sa validité ou de son utilisation, ni d'aucun problème lié à votre compte RSI.",
        "noRecourse": "Le résultat du tirage est définitif. Tout recours juridique est exclu.",
        "notAffiliated": "Fleetyards est un site de fans non officiel et n'est pas affilié à Cloud Imperium Games.",
        "version": "Conditions, version %{version}"
      },
      "claim": {
        "title": "Réclamer le prix",
        "pending": "Réclamation de votre prix…",
        "success": "Vous avez réclamé votre prix du tirage au sort « %{raffle} ». Le code cadeau est en route vers votre boîte de réception.",
        "failedTitle": "Le prix n'a pas pu être réclamé",
        "failed": "Une erreur s'est produite. Veuillez rouvrir le lien."
      },
      "meta": "Clôture le %{date} · %{count} participants",
      "metaClosed": "Clôturé le %{date} · %{count} participants",
      "showImage": "Afficher l'image %{index}",
      "howItWorks": {
        "title": "Comment ça marche",
        "enter": {
          "title": "Participez jusqu'au %{date}",
          "text": "Acceptez les conditions de participation et participez. Vous pouvez vous retirer jusqu'à la clôture du tirage au sort."
        },
        "draw": {
          "title": "Le tirage",
          "text": "Après la clôture, tous les participants sont tirés dans un ordre aléatoire unique. Le premier dans cet ordre gagne."
        },
        "claim": {
          "title": "Réclamez sous %{days} jours",
          "text": "Le gagnant reçoit un e-mail avec un lien de réclamation. Sans clic sous %{days} jours, le suivant dans l'ordre reçoit son propre e-mail."
        },
        "code": {
          "title": "Le code arrive par e-mail",
          "text": "Un clic sur le lien envoie le code cadeau par e-mail. Il n'est jamais affiché sur ce site."
        }
      },
      "entry": {
        "prize": "Lot",
        "title": "Participer au tirage au sort",
        "yours": "Votre participation",
        "closes": "Clôture",
        "closed": "Clôturé",
        "claimPeriod": "Délai de réclamation",
        "days": "%{days} jours",
        "entered": "Vous participez. Le tirage a lieu après le %{date}.",
        "enteredHint": "Si vous gagnez, nous vous envoyons un lien de réclamation par e-mail. Surveillez votre boîte de réception pendant %{days} jours après le tirage.",
        "over": "Tirage au sort terminé",
        "opensAt": "Ouverture le %{date}.",
        "maintainer": "Les mainteneurs gèrent les tirages au sort et ne peuvent pas y participer.",
        "emailRequired": "Ajoutez une adresse e-mail à votre compte pour participer. Le lot est envoyé par e-mail, et votre compte n'en a pas encore.",
        "emailMissing": "Votre compte n'a pas d'adresse e-mail : un lot ne pourrait pas vous parvenir et votre participation sera ignorée lors du tirage. Ajoutez-en une avant le %{date}."
      },
      "slider": {
        "label": "Carrousel d'images",
        "previous": "Image précédente",
        "next": "Image suivante"
      },
      "home": {
        "view": "Voir le tirage",
        "panelTitle": "Tirage au sort",
        "entered": "Inscrit",
        "notEntered": "Vous ne participez pas encore.",
        "enter": "Participer",
        "pillTag": "Tirage",
        "endsIn": {
          "one": "se termine dans %{count} jour",
          "other": "se termine dans %{count} jours"
        },
        "endsToday": "se termine aujourd'hui"
      },
      "mine": {
        "raffle": "Tirage au sort",
        "enteredAt": "Inscription",
        "outcome": "Résultat",
        "claimBy": "Consultez vos e-mails et réclamez avant le %{date}",
        "outcomes": {
          "open": "Ouvert",
          "waiting": "En attente du tirage",
          "won": "Gagné",
          "claimed": "Réclamé",
          "forfeited": "Non réclamé à temps",
          "not_won": "Non gagné"
        }
      },
      "preview": {
        "title": "Aperçu",
        "text": "Vous consultez ce tirage au sort via un lien d'aperçu. Tant qu'il n'est pas publié, seules les personnes disposant du lien peuvent le voir."
      }
    }
  }
}
